/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookingTolerancesCreateRequest,
    BookingTolerancesCreateRequestFromJSON,
    BookingTolerancesCreateRequestToJSON,
    BookingTolerancesFormConfiguration,
    BookingTolerancesFormConfigurationFromJSON,
    BookingTolerancesFormConfigurationToJSON,
    BookingTolerancesFormData,
    BookingTolerancesFormDataFromJSON,
    BookingTolerancesFormDataToJSON,
    BookingTolerancesFormValidationData,
    BookingTolerancesFormValidationDataFromJSON,
    BookingTolerancesFormValidationDataToJSON,
    BookingTolerancesUpdateRequest,
    BookingTolerancesUpdateRequestFromJSON,
    BookingTolerancesUpdateRequestToJSON,
} from '../models';

export interface ApiBookingTolerancesBookingTolerancesFormCreatePostRequest {
    bookingTolerancesCreateRequest?: BookingTolerancesCreateRequest;
}

export interface ApiBookingTolerancesBookingTolerancesFormDataGetRequest {
    id?: string;
}

export interface ApiBookingTolerancesBookingTolerancesFormUpdatePostRequest {
    bookingTolerancesUpdateRequest?: BookingTolerancesUpdateRequest;
}

export interface ApiBookingTolerancesBookingTolerancesFormValidatePostRequest {
    bookingTolerancesFormData?: BookingTolerancesFormData;
}

/**
 * no description
 */
export class BookingTolerancesFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormConfigurationGetRaw(): Promise<runtime.ApiResponse<BookingTolerancesFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingTolerancesFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormConfigurationGet(): Promise<BookingTolerancesFormConfiguration> {
        const response = await this.apiBookingTolerancesBookingTolerancesFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormCreatePostRaw(requestParameters: ApiBookingTolerancesBookingTolerancesFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingTolerancesCreateRequestToJSON(requestParameters.bookingTolerancesCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormCreatePost(requestParameters: ApiBookingTolerancesBookingTolerancesFormCreatePostRequest): Promise<void> {
        await this.apiBookingTolerancesBookingTolerancesFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormDataGetRaw(requestParameters: ApiBookingTolerancesBookingTolerancesFormDataGetRequest): Promise<runtime.ApiResponse<BookingTolerancesFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingTolerancesFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormDataGet(requestParameters: ApiBookingTolerancesBookingTolerancesFormDataGetRequest): Promise<BookingTolerancesFormData> {
        const response = await this.apiBookingTolerancesBookingTolerancesFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormUpdatePostRaw(requestParameters: ApiBookingTolerancesBookingTolerancesFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingTolerancesUpdateRequestToJSON(requestParameters.bookingTolerancesUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormUpdatePost(requestParameters: ApiBookingTolerancesBookingTolerancesFormUpdatePostRequest): Promise<void> {
        await this.apiBookingTolerancesBookingTolerancesFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormValidatePostRaw(requestParameters: ApiBookingTolerancesBookingTolerancesFormValidatePostRequest): Promise<runtime.ApiResponse<BookingTolerancesFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingTolerances/BookingTolerancesForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingTolerancesFormDataToJSON(requestParameters.bookingTolerancesFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingTolerancesFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingTolerancesBookingTolerancesFormValidatePost(requestParameters: ApiBookingTolerancesBookingTolerancesFormValidatePostRequest): Promise<BookingTolerancesFormValidationData> {
        const response = await this.apiBookingTolerancesBookingTolerancesFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
